module.exports = __webpack_public_path__ + "static/img/167360244.7718f46a.png";